import React from 'react';
import { Navigate } from 'react-router-dom';

type FeatureFlagGateProps = {
  /** Return true when the guarded UI should render. */
  when: () => boolean;
  /** Where to send the user when `when()` is false after flags have loaded. */
  redirectTo: string;
  /** False until GET /config/feature-flags completes for this session. */
  featureFlagsReady: boolean;
  /** Bumped after the feature-flag fetch so this gate re-evaluates. */
  featureFlagsRevision: number;
  children: React.ReactNode;
};

/**
 * Blocks route content until feature flags are loaded, then redirects if the flag is off.
 * Used with a single App-level fetch — not one request per flag.
 */
const FeatureFlagGate: React.FC<FeatureFlagGateProps> = ({
  when,
  redirectTo,
  featureFlagsReady,
  featureFlagsRevision,
  children,
}) => {
  void featureFlagsRevision;

  if (!featureFlagsReady) {
    return null;
  }

  if (!when()) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default FeatureFlagGate;
